import { LAYOUTS, POSITION } from "@voltmoney/types";
import { AspectRatioToken, BorderRadiusTokens, ColorTokens, FontDecorationToken, FontFamilyTokens, FontSizeTokens, GridItemTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, PromotionCardType, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { SideBarBuilderDS } from "../sideNavBar";
import sharedPropsService from "../../SharedPropsService";
import { PartnerHeader } from "./partnerHeader";
import { ACTION } from "./types";
import { goToAccountDetails, goToMarketing, handleConnection, InviteClient, onChangeTab, onKnowMore, onLogoutPress, openMenu, promoBannerInvite, RegisterClient } from "./actions";
import { config, partnerApi, StoreKey } from "../../configs/api";
import { appendURlWithParam, isAccessTokenStale, isMobile, setAppHeader, showPromoCard } from "../../configs/utils";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { BottomNavBuilderDS } from "../bottomNav";
import { getAppHeader, initializeFirebase } from "../../configs/config";
import { PartnerAccountType, PLATFORM_CODE } from "../../configs/constants";
import { getCardDataFromFireBase, navigateByUrl, ShowNewRmContactButton } from "./utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
const _isMobile = isMobile();
const trackDashboardItem = (partnerAccountType) => {
    if (partnerAccountType === PartnerAccountType.AFFILIATE) {
        return ([
            {
                id: 'lead',
                name: 'Leads',
                icon: {
                    name: IconTokens.Lead3,
                    size: IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.CHANGE_TAB,
                    payload: {
                        routeId: ROUTE.PARTNER_LEAD
                    }
                }
            },
            {
                id: 'customer',
                name: 'Customers',
                icon: {
                    name: IconTokens.Customer3,
                    size: IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.CHANGE_TAB,
                    payload: {
                        routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
                    }
                }
            },
        ]);
    }
    return [
        {
            id: 'lead',
            name: 'Pending applications',
            icon: {
                name: IconTokens.Lead3,
                size: IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.CHANGE_TAB,
                payload: {
                    routeId: ROUTE.PARTNER_LEAD
                }
            }
        },
        {
            id: 'customer',
            name: 'Completed applications',
            icon: {
                name: IconTokens.Customer3,
                size: IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.CHANGE_TAB,
                payload: {
                    routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
                }
            }
        },
        {
            id: 'partner',
            name: 'Partners',
            icon: {
                name: IconTokens.Partner3,
                size: IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.CHANGE_TAB,
                payload: {
                    routeId: ROUTE.PARTNER_REFERRED_PARTNER
                }
            }
        },
    ];
};
const startEarningItem = (_link, partnerAccountType) => {
    if (partnerAccountType && partnerAccountType === PartnerAccountType.AFFILIATE) {
        return [
            {
                id: 'invite',
                name: _isMobile ? 'Share unique link' : '  Share unique   link',
                icon: {
                    name: IconTokens.Share4,
                    size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.INVITE_CLIENT,
                    payload: {
                        link: _link ? _link : ''
                    }
                }
            },
        ];
    }
    if (partnerAccountType && partnerAccountType !== PartnerAccountType.INDIVIDUAL) {
        return [
            {
                id: 'invite',
                name: _isMobile ? 'Share unique link' : '  Share unique   link',
                icon: {
                    name: IconTokens.Share4,
                    size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.INVITE_CLIENT,
                    payload: {
                        link: _link ? _link : ''
                    }
                }
            },
            {
                id: 'marketing',
                name: 'Marketing collaterals',
                icon: {
                    name: IconTokens.Megaphone,
                    size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.MARKETING,
                    payload: {
                        routeId: ROUTE.COLLATERAL
                    }
                }
            },
            {
                id: 'checkLimit',
                name: 'FREE eligibility check in 15s',
                icon: {
                    name: IconTokens.Meter_1,
                    size: _isMobile ? IconSizeTokens.XXXXL : IconSizeTokens.XXXXXL
                },
                action: {
                    routeId: ROUTE.PARTNER_DASHBOARD_V2,
                    type: ACTION.MARKETING,
                    payload: {
                        routeId: ROUTE.PARTNER_CHECK_LIMIT
                    }
                }
            }
        ];
    }
    return [
        {
            id: 'registerCustomer',
            name: 'Register customer',
            icon: {
                name: IconTokens.ADD_FRIEND,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.REGISTER_CLIENT,
                payload: {}
            }
        },
        {
            id: 'invite',
            name: _isMobile ? 'Share unique link' : '  Share unique   link',
            icon: {
                name: IconTokens.Share4,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.INVITE_CLIENT,
                payload: {
                    link: _link ? _link : ''
                }
            }
        },
        {
            id: 'marketing',
            name: 'Marketing collaterals',
            icon: {
                name: IconTokens.Megaphone,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.MARKETING,
                payload: {
                    routeId: ROUTE.COLLATERAL
                }
            }
        },
        {
            id: 'checkLimit',
            name: 'FREE eligibility check in 15s',
            icon: {
                name: IconTokens.Meter_1,
                size: _isMobile ? IconSizeTokens.XXXXL : IconSizeTokens.XXXXXL
            },
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.MARKETING,
                payload: {
                    routeId: ROUTE.PARTNER_CHECK_LIMIT
                }
            }
        },
    ];
};
const startEarningItemFilter = (_link, partnerAccountType, user) => {
    let finalEarningItems = startEarningItem(_link, partnerAccountType);
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showCollaterals == false) {
        finalEarningItems = finalEarningItems?.filter(item => {
            return item?.id !== 'marketing';
        });
    }
    if (partnerDashboardConfig?.showCheckEligibility == false) {
        finalEarningItems = finalEarningItems?.filter(item => {
            return item?.id !== 'checkLimit';
        });
    }
    return finalEarningItems;
};
const trackDashboardItemFilter = (partnerAccountType, user) => {
    let finalEarningItems = trackDashboardItem(partnerAccountType);
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showPendingApplications == false) {
        finalEarningItems = finalEarningItems?.filter(item => {
            return item?.id !== 'lead';
        });
    }
    if (partnerDashboardConfig?.showCompletedApplications == false) {
        finalEarningItems = finalEarningItems?.filter(item => {
            return item?.id !== 'customer';
        });
    }
    if (partnerDashboardConfig?.showMarketingPage == false) {
        finalEarningItems = finalEarningItems?.filter(item => {
            return item?.id !== 'partner';
        });
    }
    if (finalEarningItems?.length === 0)
        return [];
    return finalEarningItems;
};
export const template = async (partnerName, _link, accountDetailNotPresent, partnerAccountType, openNewTab, showNewRmContactButton, rmData, partnerCardData, isFromMobile, user) => ({
    layout: {
        id: ROUTE.PARTNER_DASHBOARD_V2,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'partnerHeader', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            isFromMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
            accountDetailNotPresent ? {
                id: 'partnerDasboardPayoutDetailStack', type: WIDGET.STACK
            } : {},
            { id: 'partnerDashboardBody', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ],
    },
    datastore: {
        partnerDashboardBody: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                {
                    id: 'partnerDashboardSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboardBodyT1', type: WIDGET.TEXT
                },
                {
                    id: 'partnerDashboardSpace1', type: WIDGET.SPACE
                },
                showPromoCard(partnerAccountType) ? partnerCardData ? {
                    id: 'partnerPromotionCard1', type: WIDGET.PARTNER_PROMOTION_CARD
                } : {
                    id: 'partnerPromoScroll', type: WIDGET.SCROLL_STACK
                } : {},
                {
                    id: 'partnerDashboardSpace2', type: WIDGET.SPACE
                },
                startEarningItemFilter(partnerAccountType, user) ? {
                    id: 'partnerDashboardBodyT2', type: WIDGET.TEXT
                } : {},
                {
                    id: 'partnerDashboardSpace3', type: WIDGET.SPACE
                },
                {
                    id: 'StartEarningContainer', type: WIDGET.STACK
                },
                {
                    id: 'partnerDashboardSpace4', type: WIDGET.SPACE
                },
                showPromoCard(partnerAccountType) ? {
                    id: 'partnerJoinedStackMob_1', type: WIDGET.STACK
                } : {},
                {
                    id: 'partnerDashboardSpace5', type: WIDGET.SPACE
                },
                trackDashboardItemFilter(partnerAccountType, user)?.length > 0 ? {
                    id: 'partnerDashboardBodyT3', type: WIDGET.TEXT
                } : {},
                {
                    id: 'partnerDashboardSpace6', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboardTrackStatusStack', type: WIDGET.STACK
                },
                {
                    id: 'partnerDashboardSpace7', type: WIDGET.SPACE
                },
            ],
        },
        partnerPromotionCard1: {
            data: partnerCardData
        },
        partnerDasboardPayoutDetailStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.MD,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                bottom: SizeTypeTokens.MD,
            },
            bgColor: ColorTokens.Primary_100,
            widgetItems: [
                { id: 'partnerDasboardPayoutDetailStackT1', type: WIDGET.TEXT },
                { id: 'partnerDasboardPayoutDetailStackS1', type: WIDGET.STACK },
            ]
        },
        partnerDasboardPayoutDetailStackS1: {
            type: StackType.row,
            widgetItems: [
                { id: 'partnerDasboardPayoutDetailStackT2', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.GO_TO_ACCOUNT_DETAIL,
                payload: {
                    routeId: ROUTE.MY_ACCOUNT,
                    params: 'payoutDetails'
                }
            }
        },
        partnerDasboardPayoutDetailStackT1: {
            label: `Complete your payout profile. `,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Milk,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: _isMobile ? 18 : 20,
        },
        partnerDasboardPayoutDetailStackT2: {
            label: `Start now`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Milk,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: _isMobile ? 18 : 20,
            textDecorationLine: FontDecorationToken.underline
        },
        partnerDashboardTrackStatusStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'partnerDashboardTrackStatusStackGridItems', type: WIDGET.GRIDITEM }
            ]
        },
        //@ts-expect-error
        partnerDashboardTrackStatusStackGridItems: {
            type: GridItemTypeTokens.DASHBOARD_ITEM,
            dashboardMenuItems: trackDashboardItemFilter(partnerAccountType, user),
            noOfCols: _isMobile ? 3 : 4,
            isMobile: _isMobile
        },
        partnerDashboard_partnerStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_partnerStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_partnerStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_partnerStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                payload: {
                    routeId: ROUTE.PARTNER_REFERRED_PARTNER
                }
            }
        },
        partnerDashboard_partnerStackT1: {
            label: `Partners`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_partnerStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_partnerStackI1: {
            name: IconTokens.Partner3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace2: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_earningStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_earningStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_earningStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_earningStackT1', type: WIDGET.TEXT
                }
            ],
            // action: {
            //   type: ACTION.CHANGE_TAB,
            //   routeId: ROUTE.PARTNER_DASHBOARD_V2,
            //   payload: {
            //     routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
            //   }
            // }
        },
        partnerDashboard_earningStackT1: {
            label: `Earnings`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_earningStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_earningStackI1: {
            name: IconTokens.Earning3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace1: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_customerStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            height: StackHeight.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_customerStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_customerStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_customerStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                payload: {
                    routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER
                }
            }
        },
        partnerDashboard_customerStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboard_customerStackT1: {
            label: `Customers`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_customerStackI1: {
            name: IconTokens.Customer3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboardTrackStatusStackSpace0: {
            size: !_isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.LG
        },
        partnerDashboard_leadsStack: {
            type: StackType.column,
            flex: 1,
            height: StackHeight.MATCH_PARENT,
            maxWidth: _isMobile ? 110 : 160,
            minWidth: _isMobile ? 98 : 160,
            maxHeight: _isMobile ? 110 : 160,
            minHeight: _isMobile ? 98 : 160,
            marginRight: _isMobile ? 16 : 24,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'partnerDashboard_leadsStackI1', type: WIDGET.ICON
                },
                {
                    id: 'partnerDashboard_leadsStack_Space0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboard_leadsStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                type: ACTION.CHANGE_TAB,
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                payload: {
                    routeId: ROUTE.PARTNER_LEAD
                }
            }
        },
        partnerDashboard_leadsStackI1: {
            name: IconTokens.Lead3,
            size: IconSizeTokens.XXXXXL
        },
        partnerDashboard_leadsStackT1: {
            label: `Leads`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboard_leadsStack_Space0: {
            size: SizeTypeTokens.LG
        },
        partnerDashboardOPromoContainer: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                {
                    id: 'partnerDashboardPromoCard0', type: WIDGET.PROMOTION_CARD
                },
                {
                    id: 'partnerDashboardPromoSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboardPromoCard2', type: WIDGET.PROMOTION_CARD
                },
                {
                    id: 'partnerDashboardPromoSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'partnerDashboardPromoCard', type: WIDGET.PROMOTION_CARD
                },
            ],
        },
        partnerPromoScroll: {
            width: '100%',
            widgetItems: [
                {
                    id: 'partnerDashboardOPromoContainer', type: WIDGET.STACK
                },
            ]
        },
        partnerDashboardPromoCard2: {
            title: 'something',
            action: {
                type: ACTION.KNOW_MORE,
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                payload: {},
            },
            type: PromotionCardType.DASHBOARD_INVITE_AND_EARN,
            isCta: true,
        },
        partnerJoinedStackMob_1: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            bgColor: ColorTokens.Yellow_10,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderColor: ColorTokens.Orange_200,
                borderRadius: BorderRadiusTokens.BR1,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD,
                left: SizeTypeTokens.MD,
                right: SizeTypeTokens.MD,
            },
            widgetItems: [
                { id: 'partnerJoinedStackMobIcon1_1', type: WIDGET.IMAGE },
                { id: 'partnerJoinedMobSpace0', type: WIDGET.SPACE },
                { id: 'partnerJoinedMobT1_1', type: WIDGET.TEXT },
            ],
        },
        partnerJoinedMobT1_1: {
            label: `Through Volt Money, 2000+ partners save 15% of their AUM from redemptions annually`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 16,
        },
        partnerJoinedStackMobIcon1_1: {
            // name: IconTokens.GoldenThunder,
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/goldenThunder3x.png',
            aspectRatio: AspectRatioToken.A1_1,
            size: ImageSizeTokens.XXS,
            // size: IconSizeTokens.MD,
        },
        partnerDashboardBodyT1: {
            label: `Welcome, ${partnerName}`,
            fontSize: _isMobile ? FontSizeTokens.MD : FontSizeTokens.XXL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '700',
            lineHeight: _isMobile ? 24 : 32
        },
        partnerDashboardBodyT2: {
            label: `START EARNING`,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: 20
        },
        partnerDashboardBodyT3: {
            label: `TRACK STATUS`,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: 20
        },
        partnerDashboardPromoCard: {
            title: 'Educate your customers \n' +
                'using co-branded collateral',
            subtitle: 'Share with your clients on WhatsApp or social media',
            isCta: true,
            ctaText: 'Get collateral for FREE',
            type: PromotionCardType.DASHBOARD,
            action: {
                type: ACTION.PROMO_INVITE,
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                payload: {}
            }
        },
        // partnerDashboardPromoCard0: <Promotion_Card_Props> {
        //   title: 'Win Assured iPhone 15',
        //   subtitle: 'Join THE MARCH MEGA CONTEST!',
        //   isCta: false,
        //   ctaText: 'Claim your iPhone',
        //   type: PromotionCardType.DASHBOARD,
        //   openCta: true,
        // },
        StartEarningContainer: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'StartEarningContainerGrid', type: WIDGET.GRIDITEM }
                // { id: 'registerClientStack', type: WIDGET.STACK },
                // { id: 'StartEarningContainerSpace0', type: WIDGET.SPACE },
                // { id: 'inviteClientStack', type: WIDGET.STACK },
            ]
        },
        //@ts-expect-error
        StartEarningContainerGrid: {
            noOfCols: _isMobile ? 3 : 4,
            type: GridItemTypeTokens.DASHBOARD_ITEM,
            dashboardMenuItems: startEarningItemFilter(_link, partnerAccountType, user),
            isMobile: _isMobile
        },
        inviteClientStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'inviteClientStackI1', type: WIDGET.ICON
                },
                {
                    id: 'inviteClientStackSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'inviteClientStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.INVITE_CLIENT,
                payload: {
                    link: _link
                }
            }
        },
        inviteClientStackI1: {
            name: IconTokens.ShareLink2,
            size: IconSizeTokens.XXXXXL
        },
        inviteClientStackT1: {
            label: `Share unique link`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        registerClientStack: {
            type: StackType.column,
            flex: 1,
            maxWidth: _isMobile ? 110 : 160,
            padding: {
                left: SizeTypeTokens.MD,
                right: SizeTypeTokens.MD,
                top: SizeTypeTokens.XXL,
                bottom: SizeTypeTokens.XXL
            },
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.Size1
                },
                borderRadius: BorderRadiusTokens.BR1
            },
            widgetItems: [
                {
                    id: 'registerClientStackI1', type: WIDGET.ICON
                },
                {
                    id: 'registerClientStackSpace0', type: WIDGET.SPACE
                },
                {
                    id: 'registerClientStackT1', type: WIDGET.TEXT
                }
            ],
            action: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.REGISTER_CLIENT,
                payload: {}
            }
        },
        registerClientStackI1: {
            name: IconTokens.ADD_FRIEND,
            size: IconSizeTokens.XXL
        },
        registerClientStackT1: {
            label: `Register customer`,
            fontSize: _isMobile ? FontSizeTokens.XS : FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: _isMobile ? 18 : 24,
            textAlign: TextAlignTokens.center
        },
        partnerDashboardSpace0: {
            size: SizeTypeTokens.XL
        },
        partnerDashboardSpace1: {
            size: SizeTypeTokens.XXL
        },
        partnerDashboardSpace2: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXL
        },
        partnerDashboardSpace3: {
            size: SizeTypeTokens.XL
        },
        partnerDashboardSpace4: {
            size: _isMobile ? SizeTypeTokens.XXL : SizeTypeTokens.Size32
        },
        partnerDashboardSpace5: {
            size: SizeTypeTokens.Size32
        },
        partnerDashboardSpace6: {
            size: SizeTypeTokens.XL
        },
        partnerDashboardSpace7: {
            size: SizeTypeTokens.XL
        },
        registerClientStackSpace0: {
            size: SizeTypeTokens.LG
        },
        inviteClientStackSpace0: {
            size: SizeTypeTokens.LG
        },
        StartEarningContainerSpace0: {
            size: SizeTypeTokens.XXL
        },
        partnerJoinedMobSpace0: {
            size: SizeTypeTokens.SM,
        },
        partnerDashboardPromoSpace0: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XL,
        },
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_DASHBOARD_V2,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.PARTNER_DASHBOARD_V2),
        ...await SideBarBuilderDS(ROUTE.PARTNER_DASHBOARD_V2),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_DASHBOARD_V2)
    }
});
export const PartnerWebDashboardPageMF = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    onLoad: async ({ asyncStorage, network, navigate, instrumentTrack, initializeAmplitudeForPartner, addUseProperty, openNewTab, ...props }, { setIsUserLoggedIn: boolean, isRegisterLeads, }) => {
        appendURlWithParam('dashboard');
        await setAppHeader(null, addUseProperty);
        initializeAmplitudeForPartner('', config.PARTNER_AMPLITUDE_CONFIG);
        if (await isAccessTokenStale({ asyncStorage, network })) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        await initializeFirebase();
        const isFromMobile = isMobile();
        console.log(isFromMobile, "skm isFromMobile");
        const partnerCardData = await getCardDataFromFireBase();
        const dashboardActiveId = localStorage.getItem('DASHBOARD_ACTIVE_ID');
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        const external_route = await asyncStorage.get(StoreKey.EXTERNAL_ROUTE);
        console.log("external_route: ", external_route);
        if (external_route && external_route !== '') {
            await asyncStorage.remove(StoreKey.EXTERNAL_ROUTE);
            await navigateByUrl(ROUTE.PARTNER_CHECK_LIMIT, openNewTab, true);
            return;
        }
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        const header = await getAppHeader();
        let response = await network.post(partnerApi.userContext, {}, { headers: header }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        const _user = response?.data;
        if (response?.status === 200) {
            const platformCode = _user?.linkedPlatformAccounts[0]?.platformCode;
            if (platformCode === PLATFORM_CODE.SDK_INVESTWELL) {
                //redirect to leads
                return navigateByUrl(ROUTE.PARTNER_LEAD, openNewTab, true);
            }
        }
        const accountId = _user?.linkedPartnerAccounts[0].accountId;
        const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
        const partnerEmail = _user?.linkedPartnerAccounts[0]?.accountHolderEmail || "";
        initializeAmplitudeForPartner(accountId, config.PARTNER_AMPLITUDE_CONFIG);
        if (!partnerEmail || partnerEmail === "") {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        await sharedPropsService.setPartnerSideBarActiveId(dashboardActiveId);
        const responseInvestorLink = await network.get(`${partnerApi.investorLink}${accountId}`, {
            headers: header
        }, async () => { return; }, {
            isPartnerPlatform: true
        });
        await asyncStorage.set(StoreKey.userContext, JSON.stringify(response?.data));
        const _link = responseInvestorLink.data.link;
        const partnerName = _user?.linkedPartnerAccounts[0]?.partnerName;
        let accountDetailNotPresent;
        if (_user?.linkedPartnerAccounts[0]?.partnerProfileDetails?.bankAccountNumber) {
            accountDetailNotPresent = false;
        }
        else {
            accountDetailNotPresent = true;
        }
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const user = await AsyncStorage.getItem("user_context");
        const userData = await JSON.parse(user);
        const partnerAccountId = userData?.linkedPartnerAccounts[0].accountId;
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        console.warn("RANJAN $$$$$", accountDetailNotPresent);
        if (isRegisterLeads) {
            await navigate(ROUTE.PARTNER_LEAD, { isRegisterLeads });
        }
        if (dashboardActiveId === 'activeCustomerPage') {
            await navigate(ROUTE.PARTNER_ACTIVE_CUSTOMER);
        }
        else if (dashboardActiveId === 'referredPartnerPage') {
            await navigate(ROUTE.PARTNER_REFERRED_PARTNER);
        }
        else {
            //
        }
        instrumentTrack("DASHBOARD_PAGE_VIEWED");
        return Promise.resolve(template(partnerName, _link, accountDetailNotPresent, partnerAccountType, openNewTab, showNewRmContactButton, rmData, partnerCardData, isFromMobile, userData));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.REGISTER_CLIENT]: RegisterClient,
        [ACTION.INVITE_CLIENT]: InviteClient,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.PROMO_INVITE]: promoBannerInvite,
        [ACTION.KNOW_MORE]: onKnowMore,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.MARKETING]: goToMarketing,
        [ACTION.GO_TO_ACCOUNT_DETAIL]: goToAccountDetails,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    },
};
